import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http.postData("/resep-obat-text", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/resep-obat-text/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/resep-obat-text`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getOrderBmhpByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/order-bmhp`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

// async function find(id: number) {
//   const response = await http.getData(`/resep-obat-text/${id}`).catch(err => {
//     ErrorAlert.showErrorAlert(err);

//     return Promise.reject(err);
//   });

//   return response;
// }

async function remove(id: number) {
  const response = await http
    .deleteData(`/resep-obat-text/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

// function print(id) {
//   window.open(`${http.getAPI()}/resep-obat-text/${id}/pdf`, "_blank");
// }

async function sendResep(id: number) {
  const response = await http
    .putData(`/resep-obat-text/${id}/send`, null)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function undoSend(id: number) {
  const response = await http
    .putData(`/resep-obat-text/${id}/undo-send`, null)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function stopResepByObat(data: {
  tanggal: string;
  register_id: number;
  obat_id: string;
  dr_id: string;
  r?: string;
}) {
  const response = await http
    .postData("/resep-obat-text/stop-obat-terjadwal", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function stopResep(resepId: number) {
  const response = await http
    .postData("/resep-obat-text/stop-obat-terjadwal", {
      resep_id: resepId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getRefRute(searchStr: string = null) {
  const response = await http
    .getDataParam("/referensi/resep-rute", {
      term: searchStr
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getRefFrekuensi(searchStr: string = null) {
  const response = await http
    .getDataParam("/referensi/resep-frekuensi", {
      term: searchStr
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getRefSediaan(searchStr: string = null) {
  const response = await http
    .getDataParam("/referensi/resep-sediaan", {
      term: searchStr
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getRefObat(searchStr: string = null, cat = null) {
  const response = await http
    .getDataParam("/referensi/obat/search", {
      params: {
        term: searchStr,
        kategori: cat ?? undefined
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

function printLembarBmhp(registerId) {
  window.open(`${http.getAPI()}/register/${registerId}/lembar-bmhp/pdf`, "_blank");
}

export default {
  create,
  update,
  // sign,
  getByRegister,
  // find,
  remove,
  // print
  stopResep,
  stopResepByObat,
  getRefRute,
  getRefFrekuensi,
  getRefSediaan,
  getRefObat,
  getOrderBmhpByRegister,
  sendResep,
  undoSend,
  printLembarBmhp
};
